"use client"

import { useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { motion, AnimatePresence } from "framer-motion"
import { Building2, Eye, Rocket, Zap, TrendingUp, Settings, Cog, Target, Gem, Trophy } from "lucide-react"
import "./aboutSection.css"

const AboutSection = () => {
  const [activeTab, setActiveTab] = useState("quienes")

  const tabVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    exit: { opacity: 0, y: -20 },
  }

  const tabs = [
    {
      key: "quienes",
      title: "Quienes Somos",
      icon: <Building2 size={24} />,
      content: {
        title: "Somos",
        lead: `Somos una empresa con más de 20 años de experiencia en el mercado, desarrollando soluciones prácticas, oportunas y efectivas de software a la medida, soporte y mantenimiento 
        para empresas públicas y privadas de los sectores industrial, comercial y de transporte. Optimizamos procesos y recursos mediante sistemas de información que han permitido maximizar 
        la productividad y rentabilidad de nuestros clientes y sus organizaciones.`,

        lead2: `Contamos con un amplio conocimiento en los sectores eléctrico, de acueducto, gas y telecomunicaciones, adquirido a través de la implementación de sistemas de información, aplicando las mejores prácticas comerciales, 
        cumpliendo con los requisitos de los entes regulatorios y mejorando los procesos y el seguimiento oportuno de la información.`,
        
        lead3: `Nuestro equipo está conformado por ingenieros de sistemas expertos en desarrollo de software y con personal capacitado para dar soporte, con amplia experiencia en empresas representativas tanto públicas como privadas de diferentes sectores de la economía. 
        Nuestra gente ha sido invaluable para el éxito de la compañía, ya que son la fuerza impulsora detrás de todo lo que hacemos.`,

        lead4: `Gracias a esta fórmula de trabajo, hoy Reactiva Soporte y Desarrollo se consolida como una de las empresas líderes en transformación digital para clientes del sector público.`,
        bgClass: "mission-bg",
        
      },
    },
    {
      key: "vision",
      title: "Visión",
      icon: <Eye size={24} />,
      content: {
        title: "Nuestra Visión",
        lead: `Con las soluciones que brinda Reactiva, proyectamos que para el año 2030 seremos una empresa reconocida a nivel nacional e internacional, enriqueciendo los procesos de nuestros 
        clientes y consolidándonos como su principal aliado en desarrollos y soporte tecnológico`,
        bgClass: "vision-bg",
      },
    },
    {
      key: "mision",
      title: "Misión",
      icon: <Rocket size={24} />,
      content: {
        title: "Nuestra Misión",
        lead: `Las grandes historias tienen personalidad. En Reactiva Soporte y Desarrollo S.A.S., generamos valor a los procesos de nuestros clientes, brindándoles las mejores soluciones tecnológicas.`,
        bgClass: "mission-bg",
      },
    },
    {
      key: "servicios",
      title: "Servicios",
      icon: <Zap size={24} />,
      content: {
        title: "Nuestros Servicios",
        values: [
          {
            title: "Auditoría y reingeniería",
            icon: <TrendingUp size={32} />,
            text: "A partir de la información almacenada, sin importar el sistema de información utilizado y de acuerdo con un requerimiento específico.",
          },
          {
            title: "Soporte y mantenimiento",
            icon: <Settings size={32} />,
            text: "De aplicativos corporativos para redes privadas empresariales. Prestando distintos niveles de servicio con tiempos de respuesta efectivos.",
          },
          {
            title: "Optimizacion de procesos",
            icon: <Cog size={32} />,
            text: "Relacionados con sistemas comerciales enfocados en el mejoramiento del tiempo de respuesta y la integridad de la información.",
          },
          {
            title: "Soluciones a medida",
            icon: <Target size={32} />,
            text: "Con base en las necesidades del cliente, analizamos, planificamos y ejecutamos la mejor opción para su negocio.",
          },
          {
            title: "Transformación digital",
            icon: <Gem size={32} />,
            text: "A partir de la información almacenada, sin importar el sistema de información, y de acuerdo con un requerimiento específico.",
          },
          {
            title: "CALIDAD",
            icon: <Trophy size={32} />,
            text: "Contamos con una estructura organizaciónal definida y un gran equipo con las cualidades y conocimientos necesarios para llevar acabo cualquier reto.",
          },
        ],
        bgClass: "values-bg",
      },
    },
  ]

  return (
    <section id="about" className="innovative-about">
      <div className="floating-particles">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 10 + 5}px`,
              height: `${Math.random() * 10 + 5}px`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <Container>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="section-header"
        >
          {/* Header content can be added here if needed */}
        </motion.div>

        <div className="innovative-tabs-container">
          <div className="tab-buttons">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`tab-button ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                <span className="tab-icon">{tab.icon}</span>
                {tab.title}
              </button>
            ))}
          </div>

          <div className="tab-content-wrapper">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                variants={tabVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                className={`tab-content ${tabs.find((t) => t.key === activeTab)?.content.bgClass}`}
              >
                {activeTab !== "servicios" ? (
                  <div className="text-content">
                    <h3>{tabs.find((t) => t.key === activeTab)?.content.title}</h3>
                    <p className="lead">{tabs.find((t) => t.key === activeTab)?.content.lead}</p>
                    <br></br>
                     <p className="lead">{tabs.find((t) => t.key === activeTab)?.content.lead2}</p>
                    <br></br>
                    <br></br>
                     <p className="lead">{tabs.find((t) => t.key === activeTab)?.content.lead3}</p>
                    <br></br>
                     <p className="lead">{tabs.find((t) => t.key === activeTab)?.content.lead4}</p>
                  </div>
                ) : (
                  <div className="values-grid">
                    <h3>{tabs.find((t) => t.key === activeTab)?.content.title}</h3>
                    <Row>
                      {tabs
                        .find((t) => t.key === activeTab)
                        ?.content.values?.map((value, index) => (
                          <Col md={4} key={index}>
                            <motion.div whileHover={{ y: -5 }} className="value-card">
                              <div className="value-icon">{value.icon}</div>
                              <h4>{value.title}</h4>
                              <p>{value.text}</p>
                            </motion.div>
                          </Col>
                        ))}
                    </Row>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default AboutSection
